import {Document, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import React from 'react';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  section: {
    width: '50%',
    height: '25%',
    padding: 10,
    border: '1 solid black',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    width: '100%',
  },
  title: {
    position: 'absolute',
    top: 5,
    left: 5,
    fontSize: 8,
  },
  questionLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
  },
});

export interface FlashCardPdfProps {
  title: string;
  csvData?: string[][];
}

export default function FlashCardPdf({csvData, title}: FlashCardPdfProps) {
  if (!csvData) return null;

  return (
    <Document>
      {Array.from({length: Math.ceil(csvData.length / 4)}, (_, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.page}>
          {csvData.slice(pageIndex * 4, (pageIndex + 1) * 4).map((row) => (
            <React.Fragment key={`FlashCardPdf-${row.join('-')}`}>
              <View style={styles.section}>
                <Text style={styles.title}>{title}</Text>
                <Text style={styles.questionLabel}>Question</Text>
                <Text style={styles.text}>{row[0]}</Text>
              </View>
              <View style={styles.section}>
                <Text style={styles.text}>{row[1]}</Text>
              </View>
            </React.Fragment>
          ))}
        </Page>
      ))}
    </Document>
  );
}
